/**
 * JU!CE — Carrossel escuro de sabores (<jp-image-carousel>).
 * Espec do componente no Figma (Carousel / Flavor Image Autoplay — Desktop, node 112:142):
 * autoplay a cada 4000ms, loop, pausa no hover do ponteiro e no foco do teclado,
 * respeita prefers-reduced-motion. Base é um rail com scroll-snap (funciona sem JS,
 * é só uma lista de imagens com legenda); este arquivo liga autoplay, setas, dots e o
 * realce do slide ativo (classe .is-active, ver assets/jp-flavor-carousel.css).
 *
 * Nome do custom element é diferente de <jp-flavor-carousel>, já registrado em
 * assets/jp-sabores.js (agente H1) para outro carrossel — evita colisão no registry.
 */
(function () {
  'use strict';

  if (customElements.get('jp-image-carousel')) return;

  var reduceMotionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  class JpImageCarouselElement extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.dotsWrap = this.querySelector('[data-dots]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.autoplayToggle = this.parentElement
        ? this.parentElement.querySelector('[data-autoplay-toggle]')
        : null;
      if (!this.track) return;

      this.slides = Array.prototype.slice.call(this.track.querySelectorAll('[data-slide]'));
      if (!this.slides.length) return;

      this.interval = parseInt(this.getAttribute('data-interval'), 10) || 4000;
      this.activeIndex = 0;
      this.paused = false;
      this.manuallyPaused = false;
      this.timer = null;

      this.buildDots();
      this.bindNav();
      this.bindPause();
      this.bindAutoplayToggle();

      this._onScroll = this.onScroll.bind(this);
      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      this.setActive(0);

      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this.track && this._onScroll) this.track.removeEventListener('scroll', this._onScroll);
    }

    buildDots() {
      if (!this.dotsWrap || this.slides.length < 2) return;
      this.dotsWrap.innerHTML = '';
      var self = this;
      this.dots = this.slides.map(function (slide, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'jp-flavor-carousel__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Ir para o slide ' + (index + 1));
        dot.addEventListener('click', function () {
          self.goTo(index);
        });
        self.dotsWrap.appendChild(dot);
        return dot;
      });
    }

    bindNav() {
      var self = this;
      if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.step(-1); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.step(1); });
    }

    bindPause() {
      var self = this;
      ['mouseenter', 'focusin'].forEach(function (evt) {
        self.addEventListener(evt, function () { self.paused = true; });
      });
      ['mouseleave', 'focusout'].forEach(function (evt) {
        self.addEventListener(evt, function () {
          self.paused = false;
        });
      });
    }

    bindAutoplayToggle() {
      if (!this.autoplayToggle) return;
      var self = this;
      this.autoplayIcon = this.autoplayToggle.querySelector('[data-autoplay-icon]');
      this.autoplayLabel = this.autoplayToggle.querySelector('[data-autoplay-label]');
      this._baseLabel = this.autoplayLabel ? this.autoplayLabel.textContent : '';
      this.autoplayToggle.addEventListener('click', function () {
        self.manuallyPaused = !self.manuallyPaused;
        self.autoplayToggle.setAttribute('aria-pressed', self.manuallyPaused ? 'false' : 'true');
        if (self.autoplayLabel) {
          self.autoplayLabel.textContent = self.manuallyPaused ? 'Pausado' : self._baseLabel;
        }
        if (self.autoplayIcon) {
          self.autoplayIcon.textContent = self.manuallyPaused ? '▶' : 'Ⅱ';
        }
      });
    }

    step(direction) {
      var next = (this.activeIndex + direction + this.slides.length) % this.slides.length;
      this.goTo(next);
    }

    isRing() {
      return window.matchMedia ? window.matchMedia('(min-width: 1440px)').matches : false;
    }

    goTo(index) {
      var slide = this.slides[index];
      if (!slide) return;
      if (this.isRing()) {
        this.setActive(index);
        return;
      }
      this.track.scrollTo({
        left: slide.offsetLeft - this.track.offsetLeft,
        behavior: 'smooth'
      });
    }

    setActive(index) {
      var total = this.slides.length;
      this.activeIndex = index;
      this.slides.forEach(function (slide, i) {
        slide.setAttribute('data-pos', String((i - index + total) % total));
        slide.classList.toggle('is-active', i === index);
      });
      if (this.dots) {
        this.dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
      }
    }

    onScroll() {
      if (this.isRing()) return;
      var trackRect = this.track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var closest = 0;
      var closestDistance = Infinity;
      this.slides.forEach(function (slide, index) {
        var rect = slide.getBoundingClientRect();
        var slideCenter = rect.left + rect.width / 2;
        var distance = Math.abs(slideCenter - center);
        if (distance < closestDistance) {
          closestDistance = distance;
          closest = index;
        }
      });
      this.setActive(closest);
    }

    startAutoplay() {
      if (this.slides.length < 2) return;
      if (reduceMotionQuery && reduceMotionQuery.matches) return;
      var self = this;
      this.timer = window.setInterval(function () {
        if (self.paused || self.manuallyPaused) return;
        self.step(1);
      }, this.interval);
    }

    stopAutoplay() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  customElements.define('jp-image-carousel', JpImageCarouselElement);
})();
